import styled from 'styled-components/macro';
import * as colors from '../../../common/colorConstants';
import { lowHeightScreens, mediumScreens } from '../../../common/fontElements';

export const DecisionTreeView = styled.div`
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  padding: 0px 10px 50px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  padding: 10px 30px 200px 30px;
  align-items: center;
  flex-direction: column;
  width: 70%;
  margin: 0px auto;
  @media (max-height: ${lowHeightScreens}) {
    padding: 70px 20px 25px 20px;
  }
  @media (max-width: ${mediumScreens}) {
    width: 100%;
  }
`;

export const Title = styled.p`
  padding: 0px 30px;
  font-family: 'Lato-Bold';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

export const SubText = styled.p`
  padding: 0px 30px;
  font-family: 'Lato';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

export const TitleSection = styled.div`
  padding-bottom: 10px;
`;
